"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeBanner = void 0;
var react_1 = __importStar(require("react"));
var messageContext_1 = require("../../hoc/messageContext");
var form_1 = __importDefault(require("antd/es/form"));
var input_1 = __importDefault(require("antd/es/input"));
var button_1 = __importDefault(require("antd/es/button"));
var typography_1 = __importDefault(require("antd/es/typography"));
var row_1 = __importDefault(require("antd/es/row"));
var col_1 = __importDefault(require("antd/es/col"));
var modal_1 = __importDefault(require("antd/es/modal"));
var card_1 = __importDefault(require("antd/es/card"));
var checkbox_1 = __importDefault(require("antd/es/checkbox"));
var image_1 = __importDefault(require("antd/es/image"));
var upload_1 = __importDefault(require("antd/es/upload"));
var icons_1 = require("@ant-design/icons");
var customFetch_1 = require("../../helpers/customFetch");
var progress_1 = __importDefault(require("antd/es/progress"));
var Title = typography_1.default.Title;
var ChangeBanner = function () {
    var form = form_1.default.useForm()[0];
    var _a = (0, messageContext_1.useMessageContext)(), showSuccess = _a.showSuccess, showError = _a.showError;
    var _b = (0, react_1.useState)([]), banners = _b[0], setBanners = _b[1];
    var _c = (0, react_1.useState)(false), isModalVisible = _c[0], setIsModalVisible = _c[1];
    var _d = (0, react_1.useState)(null), editingBanner = _d[0], setEditingBanner = _d[1];
    var _e = (0, react_1.useState)(false), submitLoading = _e[0], setSubmitLoading = _e[1];
    var _f = (0, react_1.useState)(0), uploadProgress = _f[0], setUploadProgress = _f[1];
    var _g = (0, react_1.useState)(true), canUpload = _g[0], setCanUpload = _g[1];
    var _h = (0, react_1.useState)([]), fileList = _h[0], setFileList = _h[1];
    var _j = (0, react_1.useState)([]), deletedImages = _j[0], setDeletedImages = _j[1];
    var normFile = function (e) {
        var _a;
        if (Array.isArray(e)) {
            return e;
        }
        ;
        if ((((_a = e === null || e === void 0 ? void 0 : e.fileList) === null || _a === void 0 ? void 0 : _a.length) || 0) >= 2) {
            setCanUpload(false);
        }
        else {
            setCanUpload(true);
        }
        return e === null || e === void 0 ? void 0 : e.fileList;
    };
    var fetchBanners = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'banners/banner_all', method: 'GET' })];
                case 1:
                    response = _a.sent();
                    setBanners(response);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    showError('Ошибка при загрузке баннеров');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    (0, react_1.useEffect)(function () {
        fetchBanners();
    }, [fetchBanners]);
    var handleAdd = function () {
        setEditingBanner(null);
        form.resetFields();
        setIsModalVisible(true);
    };
    var handleEdit = function (banner) {
        var _a, _b, _c;
        setEditingBanner(banner);
        setDeletedImages([]);
        var image_objects = banner.image_urls.map(function (image_url, index) {
            return {
                uid: "-".concat(index + 1),
                status: 'done',
                url: image_url,
            };
        });
        setFileList(image_objects);
        setCanUpload((image_objects === null || image_objects === void 0 ? void 0 : image_objects.length) < 2);
        form.setFieldsValue({
            main_text: ((_a = banner.text) === null || _a === void 0 ? void 0 : _a.main_text) || '',
            second_text: ((_b = banner.text) === null || _b === void 0 ? void 0 : _b.second_text) || '',
            images: image_objects || '',
            image2: banner.image2 || '',
            status: (_c = banner.status) !== null && _c !== void 0 ? _c : false,
        });
        setIsModalVisible(true);
    };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/banners/").concat(id), {
                            method: 'DELETE',
                        })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        showSuccess('Баннер успешно удален');
                        setBanners(banners.filter(function (banner) { return banner.id !== id; }));
                    }
                    else {
                        showError('Ошибка при удалении баннера');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    showError('Ошибка при удалении баннера');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var method, url, formData, response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmitLoading(true);
                    setUploadProgress(0);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    method = editingBanner ? 'PATCH' : 'POST';
                    url = editingBanner
                        ? "".concat(process.env.REACT_APP_BASE_URL, "/banners/").concat(editingBanner.id)
                        : "".concat(process.env.REACT_APP_BASE_URL, "/banners");
                    formData = new FormData();
                    formData.append('banner[main_text]', values.main_text || '');
                    formData.append('banner[second_text]', values.second_text || '');
                    formData.append('banner[status]', values.status ? 'true' : 'false');
                    if (deletedImages.length > 0) {
                        formData.append('banner[deleted_images]', JSON.stringify(deletedImages));
                    }
                    if (values.images && values.images.length > 0) {
                        values.images.forEach(function (file) {
                            if (file.originFileObj) {
                                formData.append('banner[images][]', file.originFileObj);
                            }
                        });
                    }
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var xhr = new XMLHttpRequest();
                            xhr.upload.onprogress = function (event) {
                                if (event.lengthComputable) {
                                    var progress = (event.loaded / event.total) * 100;
                                    setUploadProgress(Math.round(progress));
                                }
                            };
                            xhr.onload = function () {
                                if (xhr.status >= 200 && xhr.status < 300) {
                                    resolve(xhr.response);
                                }
                                else {
                                    reject(new Error("HTTP Error: ".concat(xhr.status)));
                                }
                            };
                            xhr.onerror = function () { return reject(new Error('Network Error')); };
                            xhr.open(method, url, true);
                            xhr.send(formData);
                        })];
                case 2:
                    response = _a.sent();
                    showSuccess("\u0411\u0430\u043D\u043D\u0435\u0440 \u0443\u0441\u043F\u0435\u0448\u043D\u043E ".concat(editingBanner ? 'обновлен' : 'добавлен'));
                    setIsModalVisible(false);
                    fetchBanners();
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    showError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 ".concat(editingBanner ? 'обновлении' : 'добавлении', " \u0431\u0430\u043D\u043D\u0435\u0440\u0430"));
                    return [3 /*break*/, 5];
                case 4:
                    setSubmitLoading(false);
                    setUploadProgress(0);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { style: { padding: '20px' } },
        react_1.default.createElement(Title, { level: 1, style: { marginBottom: '20px' } }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C/\u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0431\u0430\u043D\u043D\u0435\u0440\u044B"),
        react_1.default.createElement(button_1.default, { type: "primary", onClick: handleAdd, style: { marginBottom: '20px' } }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0431\u0430\u043D\u043D\u0435\u0440"),
        react_1.default.createElement(row_1.default, { gutter: [16, 16] }, banners.length > 0 ? (banners.map(function (banner) {
            var _a;
            return (react_1.default.createElement(col_1.default, { key: banner.id, xs: 24, sm: 12, md: 8, lg: 6, style: { filter: banner.status ? 'none' : 'grayscale(1)' } },
                react_1.default.createElement(card_1.default, { hoverable: true, cover: react_1.default.createElement("div", { style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                        } }, banner.image_urls.map(function (url) { return (react_1.default.createElement(image_1.default, { loading: "lazy", src: url, alt: "example", style: {
                            height: '200px',
                            objectFit: 'cover',
                            filter: banner.status ? 'none' : 'grayscale(100%) brightness(0.8)',
                        } })); })), actions: [
                        react_1.default.createElement(button_1.default, { key: "edit", type: "text", onClick: function () { return handleEdit(banner); } }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C"),
                        react_1.default.createElement(button_1.default, { key: "delete", type: "text", danger: true, onClick: function () { return handleDelete(banner.id); } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"),
                    ] },
                    react_1.default.createElement(card_1.default.Meta, { title: banner.text ? Object.values(banner.text).filter(Boolean).join('\n') : '', description: ((_a = banner.text) === null || _a === void 0 ? void 0 : _a.second_text) || '' }))));
        })) : (react_1.default.createElement("div", { style: { textAlign: 'center', padding: '20px' } },
            react_1.default.createElement(typography_1.default.Text, { type: "secondary" }, "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0431\u0430\u043D\u043D\u0435\u0440\u043E\u0432")))),
        react_1.default.createElement(modal_1.default, { title: "".concat(editingBanner ? 'Редактировать' : 'Добавить', " \u0431\u0430\u043D\u043D\u0435\u0440"), visible: isModalVisible, onCancel: function () { return setIsModalVisible(false); }, footer: null },
            react_1.default.createElement(form_1.default, { form: form, onFinish: handleSubmit, layout: "vertical" },
                react_1.default.createElement(form_1.default.Item, { name: "main_text", rules: [{ required: true, message: 'Введите основной текст' }] },
                    react_1.default.createElement(input_1.default, { placeholder: "\u041E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u0442\u0435\u043A\u0441\u0442 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0441\u043B\u0430\u0439\u0434\u0430" })),
                react_1.default.createElement(form_1.default.Item, { name: "second_text", rules: [{ required: true, message: 'Введите второстепенный текст' }] },
                    react_1.default.createElement(input_1.default, { placeholder: "\u0412\u0442\u043E\u0440\u043E\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0441\u043B\u0430\u0439\u0434\u0430" })),
                react_1.default.createElement(form_1.default.Item, { name: "images", label: "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F", valuePropName: "fileList", getValueFromEvent: normFile },
                    react_1.default.createElement(upload_1.default, { listType: "picture-card", accept: "image/*", action: "", fileList: fileList, onRemove: function (file) {
                            if (file.url) {
                                setDeletedImages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [file.url], false); });
                            }
                        }, customRequest: function (options) {
                            var onSuccess = options.onSuccess;
                            if (onSuccess) {
                                onSuccess("Ok");
                            }
                        }, beforeUpload: function (file) {
                            var isImage = file.type.startsWith('image/');
                            if (!isImage) {
                                showError('Можно загружать только изображения!');
                                return false;
                            }
                            return true;
                        }, maxCount: 2 }, canUpload && (react_1.default.createElement("button", { style: { color: 'inherit', cursor: 'pointer', border: 0, background: 'none', padding: '8px' }, type: "button" },
                        react_1.default.createElement(icons_1.PlusOutlined, null),
                        react_1.default.createElement("div", { style: { marginTop: 8 } }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C"))))),
                react_1.default.createElement(form_1.default.Item, { name: "status", valuePropName: "checked" },
                    react_1.default.createElement(checkbox_1.default, { checked: form.getFieldValue('status') }, " \u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0439 ")),
                react_1.default.createElement(form_1.default.Item, null,
                    react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit", loading: submitLoading }, editingBanner ? 'Сохранить' : 'Добавить'),
                    uploadProgress > 0 && uploadProgress < 100 && (react_1.default.createElement(progress_1.default, { percent: uploadProgress, size: "small", style: { marginTop: 8 } })))))));
};
exports.ChangeBanner = ChangeBanner;
